<section class="breadcrumb-section">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <div class="breadcrumb-title">
                    <h1>Farewell Party 2025</h1>
                </div>
            </div>
        </div>
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="text-justify">
            <p>GHRCACS, Nagpur hosted Farewell Party 2025, celebrating the journey of outgoing students with joy,
                nostalgia, and warm wishes for the road ahead. #Farewell2025 #GHRCACS #NewBeginnings #CherishedMoments
            </p>
            <p>GHRCACS, Nagpur hosted a heartfelt Farewell Ceremony, celebrating the journey of outgoing students with
                joy, reflection, and best wishes for their next big chapter. </p>
        </div>
        <div class="row mb-20 mt-5">
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-3.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-3.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-4.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-4.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-5.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-5.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-6.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-6.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-7.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-7.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-8.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell-party-8.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>

            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell1.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell1.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell2.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell2.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell3.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell3.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell4.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell4.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            <div class="col-md-3 col-6">
                <div class="gallery-item" data-aos="zoom-in-down">
                    <a href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell5.webp"
                        data-lightbox="example-set" data-title="GHRCCST GALLERY GLIMPSES">
                        <img class="img-fluid"
                            src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrccst/assets/images/events/farewell5.webp"
                            alt="EVENTS | GHRCACSN">
                        <div class="gallery-overlay"></div>
                    </a>
                </div>
            </div>
            
        </div>
    </div>
</section>